import { BrowserRouter, Navigate, Route, Routes } from "react-router";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import { ROUTE_NAME } from "./types/CommonTypes";
import RouteWrapper from "../components/RouteWrapper";
import RecoverUsername from "../pages/RecoverUsername";
import ResetPassword from "../pages/ResetPassword";
import Dashboard from "../pages/Dashboard";
import CaseDetail from "../pages/CaseDetail";

const Login = lazy(() => import("../pages/Login"));
const VerifyIdentity = lazy(() => import("../pages/VerifyIdentity"));
const VerifyOTP = lazy(() => import("../pages/VerifyOTP"));
const SetAccountPassword = lazy(() => import("../pages/SetAccountPassword"));
const AccountPasswordUpdated = lazy(
  () => import("../pages/AccountPasswordUpdated")
);
const TenantRouter = lazy(() => import("./TenantRouter"));
const TenantManagement = lazy(() => import("../pages/TenantManagement"));
const UserAccount = lazy(() => import("../pages/UserAccount"));
const ChangePassword = lazy(() => import("../pages/ChangePassword"));
const Support = lazy(() => import("../pages/Support"));
const Alerts = lazy(() => import("../pages/Alerts"));
const CaseManagement = lazy(() => import("../pages/CaseManagement"));
const CaseBoard = lazy(() => import("../pages/CaseBoard"));

const CodingManagement = lazy(() => import("../pages/CodingManagement"));
const CodingRecTableList = lazy(() => import("../modules/codingModule/components/CodingRecTableList"));
const CodingDashboardScreen = lazy(() => import("../modules/codingModule/components/CodingDashboardScreen"));
const PredictionsManagement = lazy(() => import("../pages/PredictionsManagement"));

export default function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={ROUTE_NAME.DASHBOARD}
          element={<RouteWrapper element={<Dashboard />} />}
        />
        <Route
          path={ROUTE_NAME.ROOT}
          element={<RouteWrapper element={<Dashboard />} />}
        />
        <Route
          path={ROUTE_NAME.TENANT_MANAGEMENT}
          element={<RouteWrapper element={<TenantManagement />} />}
        />
        <Route
          path={ROUTE_NAME.CASE_MANAGEMENT}
          element={<RouteWrapper element={<CaseManagement />} />}
        />
        <Route
          path={ROUTE_NAME.CASE_BOARD}
          element={<RouteWrapper element={<CaseBoard />} />}
        />
        <Route
          path={ROUTE_NAME.CASE_DETAIL + "/*"}
          element={<RouteWrapper element={<CaseDetail />} />}
        />
        <Route
          path={ROUTE_NAME.ALERTS}
          element={<RouteWrapper element={<Alerts />} />}
        />

        <Route
          path={ROUTE_NAME.LOGIN}
          element={<RouteWrapper isProtected element={<Login />} />}
        />
        <Route
          path={ROUTE_NAME.RECOVER_USERNAME}
          element={<RouteWrapper isProtected element={<RecoverUsername />} />}
        />
        <Route
          path={ROUTE_NAME.RESET_PASSWORD}
          element={<RouteWrapper isProtected element={<ResetPassword />} />}
        />

        <Route
          path={ROUTE_NAME.VERIFY_IDENTITY}
          element={<RouteWrapper isProtected element={<VerifyIdentity />} />}
        />

        <Route
          path={ROUTE_NAME.VERIFY_OTP}
          element={<RouteWrapper isProtected element={<VerifyOTP />} />}
        />

        <Route
          path={ROUTE_NAME.SET_ACCOUNT_PASSWORD}
          element={
            <RouteWrapper isProtected element={<SetAccountPassword />} />
          }
        />

        <Route
          path={ROUTE_NAME.ACCOUNT_PASSWORD_UPDATE}
          element={
            <RouteWrapper isProtected element={<AccountPasswordUpdated />} />
          }
        />

        <Route
          path={ROUTE_NAME.CHANGE_PASSWORD}
          element={<RouteWrapper element={<ChangePassword />} />}
        />

        <Route
          path={
            ROUTE_NAME.TENANT_MANAGEMENT +
            "/" +
            ROUTE_NAME.TENANT_SETTINGS +
            "/*"
          }
          element={<RouteWrapper element={<TenantRouter />} />}
        />
        <Route
          path={ROUTE_NAME.USER_ACCOUNT}
          element={<RouteWrapper element={<UserAccount />} />}
        />
        <Route
          path={ROUTE_NAME.SUPPORT}
          element={<RouteWrapper element={<Support />} />}
        />
        <Route path={ROUTE_NAME.NOT_FOUND} element={<NotFound />} />
        <Route
          path="*"
          element={<Navigate replace to={"/" + ROUTE_NAME.NOT_FOUND} />}
        />

         <Route
          path={ROUTE_NAME.CODING}
          element={<RouteWrapper element={<CodingManagement />} />}
        />
        <Route
          path={ROUTE_NAME.CODING_RECOMMENDATION}
          element={<RouteWrapper element={<CodingRecTableList/>} />}
        />
         
        <Route
          path={`${ROUTE_NAME.CODING_CASE_DETAIL}/:caseId`}
          element={<RouteWrapper element={<CodingDashboardScreen />} />}
        />
        <Route
          path={ROUTE_NAME.PREDICTION}
          element={<RouteWrapper element={<PredictionsManagement/>} />}
        />
      </Routes>
    </BrowserRouter>
  );
}
